"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakePrimaryConfirm = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var constants_1 = require("../../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var addressDisplay_1 = require("./addressDisplay");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var icons_component_1 = require("../../../components/icons.component");
var interpolate_component_1 = require("../../../components/interpolate-component");
var page = require("page");
/**
 * Set Primary Confirm Component
 */
var MakePrimaryConfirm = /** @class */ (function (_super) {
    tslib_1.__extends(MakePrimaryConfirm, _super);
    function MakePrimaryConfirm(props) {
        var _this = _super.call(this, props) || this;
        _this.submitHandler = function (event) {
            event.preventDefault();
            _this.setState({ showSpinner: true });
            var formData = {};
            for (var formElementIdentifier in _this.state.form) {
                formData[formElementIdentifier] = JSON.stringify(_this.state.form[formElementIdentifier]);
            }
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.MAKE_PRIMARY, formData, { component: { name: VIEWS.ADDRESSES.MAKE_PRIMARY } })
                .then(function (response) {
                if (response && response.addresses) {
                    response.addresses = commonUtils_1.modifyObjectWithFactorById(response.addresses, _this.props.route.enter.params.id, VIEWS.ADDRESSES.TOAST_INTENTS.SET_PRIMARY, true);
                    _this.props.dispatchAddressUpdate(response);
                }
                _this.props.performedAction(VIEWS.ADDRESSES.TOAST_INTENTS.SET_PRIMARY);
                page(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.MANAGE);
            })
                .catch(function (error) {
                _this.setState({ showSpinner: false });
                var customerCareLinkComponent, errorComponent;
                customerCareLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.content.common.customerCareLink, href: _this.props.links.help.linkUrl }, _this.props.content.common.customerCareLink));
                errorComponent = interpolate_component_1.InterpolateLinksWithComponent(_this.props.content.common.error.errorGeneric, [customerCareLinkComponent]);
                _this.setState({ errorMessage: errorComponent });
                triggerOperationResult_1.triggerOperationResult(_this.props.fptiObj.setAsPrimary, FPTI.FAILURE, _this.props.content.common.genericSettingsError);
                return;
            });
        };
        _this.state = {
            form: {
                id: commonweb_utils_1.objectUtils.safeGet(props, "route.enter.params.id") || "",
            },
            showSpinner: false,
            errorMessage: "",
        };
        return _this;
    }
    MakePrimaryConfirm.prototype.render = function () {
        var content = this.props.content, addresses = this.props.addresses, makePrimaryAddressId = commonweb_utils_1.objectUtils.safeGet(this.props, "route.enter.params.id") || "", fptiObj = this.props.fptiObj, addressToBePrimary = addresses.find(function (addr) { return addr.id === makePrimaryAddressId; }), form;
        form = (React.createElement("form", { className: "fullHeight", onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { className: "dividerMargin", type: "error" }, this.state.errorMessage)) : null,
            React.createElement("div", { className: this.state.errorMessage
                    ? "formContent_center updatePageError_height"
                    : "formContent_center fullHeight" },
                React.createElement("div", null,
                    React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "illustrations-icon", image: "Info" }),
                    React.createElement("div", { className: "updateWarning-content" },
                        React.createElement(pp_react_1.Text, { size: "xl3" }, content.addresses.setPrimary.warning)),
                    React.createElement("div", { className: "componentBody-content" },
                        React.createElement(addressDisplay_1.default, { layout: addressToBePrimary &&
                                addressToBePrimary.displayMetadata.layout })))),
            React.createElement("div", { className: this.state.errorMessage
                    ? "formButton_bottom updateErrorButton_height"
                    : "formButton_bottom updateButton_height" },
                React.createElement(pp_react_1.Button, { className: "fullWidth", name: fptiObj.submitSetPrimary, type: "submit", disabled: this.state.showSpinner }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { screenReaderText: content.common.loading, inverse: true })) : (content.common.confirm)))));
        return React.createElement("div", { className: "generic-container fullHeight" }, form);
    };
    return MakePrimaryConfirm;
}(React.Component));
exports.MakePrimaryConfirm = MakePrimaryConfirm;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, fpti = _a.fpti, links = _a.links;
    var addresses = commonweb_utils_1.objectUtils.safeGet(account, "addressData.addresses") || {};
    var fptiObj = fpti.address;
    return {
        _csrf: _csrf,
        ui: ui,
        route: route,
        content: content,
        addresses: addresses,
        fptiObj: fptiObj,
        links: links,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchAddressUpdate: function (allAddresses) {
            return dispatch(addresses_1.makePrimary(allAddresses));
        },
        performedAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MakePrimaryConfirm);
